import React from 'react';
import PropTypes from 'prop-types';
import { withNavigation } from '../../actions/navigation';
import ProductCard from './ProductCard';


/**
 * Product view
 * Displays the product name and description, 
 * along with a "learn more" link to the product URL
 */

const ProductDescription = ({
    product, 
    subscription, 
    navigateToProduct, 
    navigateToSubscription
}) => (
    <ProductCard 
        navigateToProduct={navigateToProduct} 
        product={product}
        subscription={subscription}
        navigateToSubscription={navigateToSubscription} />

);

ProductDescription.propTypes = {
  product: PropTypes.object.isRequired,
  subscription: PropTypes.object,
}

export default withNavigation(ProductDescription);


// WEBPACK FOOTER //
// ./src/components/products/ProductDescription.js